import request from '@/utils/request';

// ==================== 管理员 ====================
export function adminLogin(data) {
  return request({ url: '/admin/login', method: 'post', data });
}
export function getAdminInfo() {
  return request({ url: '/admin/info', method: 'get' });
}

// ==================== 产品分类 ====================
export function getCategoryList() {
  return request({ url: '/admin/categories', method: 'get' });
}
export function saveCategory(data) {
  return request({ url: '/admin/category', method: 'post', data });
}
export function deleteCategory(id) {
  return request({ url: `/admin/category/${id}`, method: 'delete' });
}

// ==================== 产品管理 ====================
export function getProductList(params) {
  return request({ url: '/admin/products', method: 'get', params });
}
export function saveProduct(data) {
  return request({ url: '/admin/product', method: 'post', data });
}
export function deleteProduct(id) {
  return request({ url: `/admin/product/${id}`, method: 'delete' });
}

// ==================== 订单管理 ====================
export function getOrderList(params) {
  return request({ url: '/admin/orders', method: 'get', params });
}
export function createOrder(data) {
  return request({ url: '/admin/order', method: 'post', data });
}
export function getOrderDetail(id) {
  return request({ url: `/admin/order/${id}`, method: 'get' });
}
export function updateOrderStatus(id, data) {
  return request({ url: `/admin/order/status/${id}`, method: 'put', data });
}
export function updateOrder(id, data) {
  return request({ url: `/admin/order/${id}`, method: 'put', data });
}
export function assignPlayerToOrder(id, data) {
  return request({ url: `/admin/order/assign/${id}`, method: 'put', data });
}
export function flowOrderToHall(id, data) {
  return request({ url: `/admin/order/flow-to-hall/${id}`, method: 'put', data });
}
export function auditTransferOrder(id, data) {
  return request({ url: `/admin/order/transfer-audit/${id}`, method: 'put', data });
}

// ==================== 打手管理 ====================
export function getPlayerList(params) {
  return request({ url: '/admin/players', method: 'get', params });
}
export function updatePlayer(id, data) {
  return request({ url: `/admin/player/${id}`, method: 'put', data });
}
export function auditPlayer(id, data) {
  return request({ url: `/admin/player/audit/${id}`, method: 'put', data });
}
export function getPlayerDetail(id) {
  return request({ url: `/admin/player/${id}`, method: 'get' });
}
export function payDeposit(id, data) {
  return request({ url: `/admin/player/${id}/deposit`, method: 'post', data });
}
export function refundDeposit(id, data) {
  return request({ url: `/admin/player/${id}/refund-deposit`, method: 'post', data });
}
export function auditPlayerProfile(id, data) {
  return request({ url: `/admin/player/profile-audit/${id}`, method: 'put', data });
}
export function getPlayerTransactions(params) {
  return request({ url: '/admin/player/transactions', method: 'get', params });
}
export function adjustPlayerBalance(id, data) {
  return request({ url: `/admin/player/${id}/adjust-balance`, method: 'post', data });
}
export function deletePlayer(id) {
  return request({ url: `/admin/player/${id}`, method: 'delete' });
}

// ==================== 财务 - 提现 ====================
export function getWithdrawList(params) {
  return request({ url: '/admin/withdrawals', method: 'get', params });
}
export function auditWithdraw(id, data) {
  return request({ url: `/admin/withdraw/audit/${id}`, method: 'put', data });
}

// ==================== 财务 - 充值 ====================
export function getRechargeList(params) {
  return request({ url: '/admin/recharges', method: 'get', params });
}
export function manualRecharge(data) {
  return request({ url: '/admin/recharge', method: 'post', data });
}

// ==================== 财务 - 订单收入 ====================
export function getOrderIncomeList(params) {
  return request({ url: '/admin/order-incomes', method: 'get', params });
}

// ==================== 财务 - 押金记录 ====================
export function getDepositRecordList(params) {
  return request({ url: '/admin/deposit-records', method: 'get', params });
}

// ==================== 客户管理 ====================
export function getCustomerList(params) {
  return request({ url: '/admin/customers', method: 'get', params });
}
export function createCustomer(data) {
  return request({ url: '/admin/customer', method: 'post', data });
}
export function searchCustomer(params) {
  return request({ url: '/admin/customer/search', method: 'get', params });
}
export function getCustomerDetail(id, params) {
  return request({ url: `/admin/customer/${id}`, method: 'get', params });
}
export function updateCustomer(id, data) {
  return request({ url: `/admin/customer/${id}`, method: 'put', data });
}
export function rechargeCustomer(id, data) {
  return request({ url: `/admin/customer/${id}/recharge`, method: 'post', data });
}
export function refundCustomer(id, data) {
  return request({ url: `/admin/customer/${id}/refund`, method: 'post', data });
}

// ==================== 系统配置 ====================
export function getConfigs() {
  return request({ url: '/admin/configs', method: 'get' });
}
export function batchSaveConfigs(data) {
  return request({ url: '/admin/configs/batch', method: 'put', data });
}

// ==================== 等级配置 ====================
export function getLevelConfigs() {
  return request({ url: '/admin/levels', method: 'get' });
}
export function saveLevelConfig(data) {
  return request({ url: '/admin/level', method: 'post', data });
}
export function deleteLevelConfig(id) {
  return request({ url: `/admin/level/${id}`, method: 'delete' });
}

// ==================== 售后管理 ====================
export function getAfterSaleList(params) {
  return request({ url: '/admin/after-sales', method: 'get', params });
}
export function createAfterSale(data) {
  return request({ url: '/admin/after-sale', method: 'post', data });
}
export function handleAfterSale(id, data) {
  return request({ url: `/admin/after-sale/${id}`, method: 'put', data });
}

// ==================== 数据统计 ====================
export function getStatistics(params) {
  return request({ url: '/admin/statistics', method: 'get', params });
}

// ==================== 账号管理 ====================
export function getAdminList() {
  return request({ url: '/admin/admins', method: 'get' });
}
export function createAdmin(data) {
  return request({ url: '/admin/admin', method: 'post', data });
}
export function updateAdmin(id, data) {
  return request({ url: `/admin/admin/${id}`, method: 'put', data });
}
export function deleteAdmin(id) {
  return request({ url: `/admin/admin/${id}`, method: 'delete' });
}
